import { render, staticRenderFns } from "./exhibitionServices.vue?vue&type=template&id=c2033bbc&scoped=true&"
import script from "./exhibitionServices.vue?vue&type=script&lang=js&"
export * from "./exhibitionServices.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionServices.vue?vue&type=style&index=0&id=c2033bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2033bbc",
  null
  
)

export default component.exports